/**
 * `?create=<MediaKind>` on a group page opens «Создать шаблон» with that kind preselected — the
 * «Создать шаблон» button of a kind without a template on a championship's «Медиа» tab leads
 * there (IMGM-1518). The page reads it once and strips it from the address.
 */
export const CREATE_TEMPLATE_QUERY = 'create';
